import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-relative w-100" }
const _hoisted_2 = { class: "role-container tw-flex tw-justify-between tw-items-center" }
const _hoisted_3 = { class: "role-inner tw-flex tw-gap-[5px]" }
const _hoisted_4 = {
  key: 0,
  class: "placeholder-container"
}

import { PropType, ref, Ref, watch } from "vue";
import BaseDropDownItem from "@/components/common/form/baseDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import ArrowIcon from "@/components/svgs/arrowIcon.vue";
import store from "@/store";
import { OVERLAY_KEYBOARD } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'baseMultiDropDown',
  props: {
  modelValue: {
    type: Array as PropType<(string | number)[]>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  className: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  data: {
    type: Array as PropType<IDropDownData[]>,
    required: true,
  },
  options: {
    type: Array as PropType<IDropDownData[]>,
    default: () => [{}],
  },
  description: {
    type: String,
    default: "",
  },
  validation: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;

const isDropdownOpen = ref(false);


const activeItem = ref(0);

const selectedOptions: Ref<(string | number)[]> = ref(props.modelValue || []);
const showDropdow = () => {
  store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN); //
};
const handleSelect = (val: string | number) => {
  if (selectedOptions.value.includes(val)) {
    selectedOptions.value = selectedOptions.value.filter(
      (item) => item.toString() !== val.toString(),
    );
  } else {
    selectedOptions.value.push(val);
  }
  setTimeout(() => {
    store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
  }, 1000);
  emit("update:modelValue", selectedOptions.value);
};

const selectItem = (event) => {
  if (event.key == "ArrowDown") {
    isDropdownOpen.value = true;
    store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN);
  }
  if (event.key == "Enter") {
    let id: any = props.data[activeItem.value].id;
    handleSelect(id);
    isDropdownOpen.value = false; // close dropdow when select value
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
};

const moveSelectionDown = (step) => {
  if (props.data.length - 1 == activeItem.value) {
    activeItem.value = props.data.length - 1;
  } else if (activeItem.value < props.data.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};
watch(isDropdownOpen, (newValue, oldValue) => {
  if (!newValue && oldValue) {
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BDropdown = _resolveComponent("BDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BDropdown, {
      id: props.id,
      modelValue: isDropdownOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDropdownOpen).value = $event)),
      class: _normalizeClass([
        'tw-relative baseMultiDropDown',
        'focusDrop',
        __props.className,
        __props.validation.$error ? 'invalid' : '',
      ]),
      block: "",
      "menu-class": "w-100",
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(($event: any) => (moveSelectionDown(1)), ["down"])),
        _cache[2] || (_cache[2] = _withKeys(($event: any) => (moveSelectionUp(-1)), ["up"])),
        selectItem
      ],
      onShow: showDropdow
    }, {
      "button-content": _withCtx(() => [
        _renderSlot(_ctx.$slots, "button-content", {}, () => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (selectedOptions.value.length === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.placeholder), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.filter((item) =>
                  selectedOptions.value.includes(item.id),
                ), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "role tw-text-sm tw-font-medium tw-flex tw-items-center tw-px-[13px] tw-text-[#231F20]"
                }, [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]))
              }), 128))
            ]),
            _createVNode(ArrowIcon, {
              class: "right-arrow",
              width: 6.661,
              height: 10
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (option, index) => {
            return (_openBlock(), _createBlock(BaseDropDownItem, {
              id: option.id.toString(),
              key: option.id,
              selected: __props.modelValue.some((item) => item === option.id),
              text: option.name,
              "class-name": `normal-dropdown-container ${
            activeItem.value === index ? 'activeItem' : ''
          }`,
              onClick: ($event: any) => (handleSelect(option.id))
            }, null, 8, ["id", "selected", "text", "class-name", "onClick"]))
          }), 128))
        ])
      ]),
      _: 3
    }, 8, ["id", "modelValue", "class"])
  ]))
}
}

})